import React from "react";
import { useHistory } from "react-router";
import { Dialog } from "@mui/material";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import IconButtonWrapper from "../../../common/form-fields-mui/IconButtonWrapper";
import AButton from "../../../common/form-fields-mui/AButton";
import { useGetCollectPaymentContext } from "../context";
import { alertPopUpInitiator } from "./constants";

const PopupAlert = ({}) => {
  const { alertPopup, setAlertPopup, studentBasicDetails } =
    useGetCollectPaymentContext();
  const isError = alertPopup?.messageType === "ERROR_MESSAGE";
  const isFromEpmr = alertPopup?.isFromEpmr;
  const history = useHistory();
  const closeHandler = () => {
    setAlertPopup(alertPopUpInitiator);
  };
  //
const shouldOpenPopup =
  alertPopup?.isOpen &&
  (alertPopup?.titleMessage || alertPopup?.detailMessage);

  return (
    <>
      <Dialog onClose={closeHandler} open={shouldOpenPopup} maxWidth="sm">
        <div style={{ padding: "28px 24px", minWidth: "28rem" }}>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div
              className={
                isError ? "error-info-dot-error" : "error-info-dot-warning"
              }
            >
              !
            </div>
            <div>
              <IconButtonWrapper onClick={closeHandler}>
                <CrossIcon width={32} height={32} />
              </IconButtonWrapper>
            </div>
          </div>
          <div className="text-bold text-dark mb-2 large-text">
            {alertPopup?.titleMessage}
          </div>

          {/* <div> {alertPopup?.detailMessage}</div> */}
          <div
            className="dynamic-message"
            dangerouslySetInnerHTML={{ __html: alertPopup?.detailMessage }}
          />

          {studentBasicDetails?.detailsMap?.branchHasUnconfirmedEPMR ? (
            <div className="d-flex align-item-center mt-2">
              <AButton
                className="button_remove_left_margin"
                onClick={() => {
                  history.push("/admin/paymentCollection/manageEpmr");
                }}
                variant="primary_filled"
                // updatedStyle={{ width: "35%" }}
              >
                Go to “EPMR Receipts”
              </AButton>
              {/* <AButton
                onClick={() => window.close()}
                variant="general"
                updatedStyle={{ width: "40%" }}
              >
                Go Back
              </AButton> */}
            </div>
          ) : (
            <div className="d-flex align-item-center">
              <AButton
                className="button_remove_left_margin mt-2"
                onClick={closeHandler}
                variant="primary_filled"
                updatedStyle={{ width: "35%" }}
              >
                Okay
              </AButton>
            </div>
          )}
        </div>
      </Dialog>
    </>
  );
};

export default PopupAlert;
